import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { apiClient } from "../../../zodios/client";
import { useNavigate, useSearch } from "@tanstack/react-router";
import ConfirmationModal from "../../../components/core/blocks/ConfirmationModal";
import { useAppSelector } from "../../../redux/hooks";

const VerifyEmailModal = () => {
  const user = useAppSelector((state) => state.user);
  const navigate = useNavigate();
  const { t } = useTranslation(["onboarding", "common"]);

  const showEmailVerificationModal = useSearch({ strict: false, select: (s) => s.verify });

  const resendEmailVerificationEmail = useMutation({
    mutationFn: async () => await apiClient.resendVerificationEmail(undefined),
  });

  const verificationSuccessful = showEmailVerificationModal === "true" || user.email_verified_on;

  return (
    <>
      {showEmailVerificationModal && (
        <ConfirmationModal
          inlineModal={true}
          title={verificationSuccessful ? t(($) => $.onboarding["Thank You"]) : t(($) => $.onboarding.Sorry)}
          defaultShowState={true}
          confirmationMessage={
            <div className="fs-standard">
              {verificationSuccessful ?
                t(($) => $.onboarding["Your email has been successfully verified."])
              : t(
                  ($) =>
                    $.onboarding[
                      "Email verification failed. Please click the button below to send a new confirmation link."
                    ],
                )
              }
            </div>
          }
          confirmButtonText={
            verificationSuccessful ? t(($) => $.common.actions.Continue) : t(($) => $.onboarding.Resend)
          }
          onConfirm={() => {
            navigate({
              to: ".",
              search: (prev) => ({ ...prev, verify: undefined }),
              replace: true,
              resetScroll: false,
            });
            if (verificationSuccessful) {
              return;
            }

            resendEmailVerificationEmail.mutate();
          }}
          onCancel={() => {
            navigate({
              to: ".",
              search: (prev) => ({ ...prev, verify: undefined }),
              replace: true,
              resetScroll: false,
            });
          }}
          cancelButtonStyles={{
            display: verificationSuccessful ? "none" : "inherit",
          }}
        />
      )}
    </>
  );
};

export default VerifyEmailModal;
